import React from 'react';
import { cn } from '../../lib/utils';
export type ContactMethod = 'email' | 'phone' | 'listing';
interface StepOfferDetailsProps {
  rentEur: string;
  depositEur: string;
  contactMethod: ContactMethod;
  contactEmail: string;
  contactPhone: string;
  message: string;
  termsAccepted: boolean;
  tenantName: string;
  onChange: (patch: Partial<{
    rentEur: string;
    depositEur: string;
    contactMethod: ContactMethod;
    contactEmail: string;
    contactPhone: string;
    message: string;
    termsAccepted: boolean;
  }>) => void;
}
const METHODS: {
  value: ContactMethod;
  label: string;
}[] = [{
  value: 'email',
  label: 'Email'
}, {
  value: 'phone',
  label: 'Telefon'
}, {
  value: 'listing',
  label: 'Prin anunț'
}];
export function StepOfferDetails({
  rentEur,
  depositEur,
  contactMethod,
  contactEmail,
  contactPhone,
  message,
  termsAccepted,
  tenantName,
  onChange
}: StepOfferDetailsProps) {
  const phoneRequired = contactMethod === 'phone';
  return <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 space-y-6" data-id="element-2674">
      <div data-id="element-2675">
        <h2 className="text-2xl sm:text-3xl font-bold text-light-1 mb-2" data-id="element-2676">
          Detalii ofertă
        </h2>
        <p className="text-sm text-light-3" data-id="element-2677">
          Ultimul pas — propunerea pe care o vede {tenantName}.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-2678">
        <Field label="Chirie lunară (€)" data-id="element-2679">
          <input type="number" value={rentEur} onChange={e => onChange({
          rentEur: e.target.value
        })} placeholder="650" className="w-full h-11 px-3 rounded-md bg-dark-2 border border-dark-4 text-sm text-light-1 placeholder:text-light-4 focus:outline-none focus:border-lime-1 transition-colors" data-id="element-2680" />
        </Field>
        <Field label="Garanție (€)" data-id="element-2681">
          <input type="number" value={depositEur} onChange={e => onChange({
          depositEur: e.target.value
        })} placeholder="650" className="w-full h-11 px-3 rounded-md bg-dark-2 border border-dark-4 text-sm text-light-1 placeholder:text-light-4 focus:outline-none focus:border-lime-1 transition-colors" data-id="element-2682" />
        </Field>
      </div>

      <div className="space-y-2" data-id="element-2683">
        <label className="text-sm font-medium text-light-2" data-id="element-2684">
          Metodă preferată de contact
        </label>
        <div className="grid grid-cols-3 gap-2 bg-dark-2 border border-dark-4 rounded-full p-1" data-id="element-2685">
          {METHODS.map(opt => <button key={opt.value} type="button" onClick={() => onChange({
          contactMethod: opt.value
        })} className={cn('h-9 rounded-full text-sm font-medium transition-colors', contactMethod === opt.value ? 'bg-dark-4 text-light-1' : 'text-light-3 hover:text-light-2')} aria-pressed={contactMethod === opt.value} data-id="element-2686">
              {opt.label}
            </button>)}
        </div>
        <p className="text-xs text-light-3" data-id="element-2687">Câmpul ales devine obligatoriu.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-2688">
        <Field label="Email contact" data-id="element-2689">
          <input type="email" value={contactEmail} onChange={e => onChange({
          contactEmail: e.target.value
        })} placeholder="adresa@email.com" className="w-full h-11 px-3 rounded-md bg-dark-2 border border-dark-4 text-sm text-light-1 placeholder:text-light-4 focus:outline-none focus:border-lime-1 transition-colors" data-id="element-2690" />
        </Field>
        <Field label={<>
              Telefon contact{' '}
              {!phoneRequired && <span className="text-light-4 font-normal" data-id="element-2692">(opțional)</span>}
            </>} data-id="element-2691">
          <input type="tel" value={contactPhone} onChange={e => onChange({
          contactPhone: e.target.value
        })} placeholder="07XX XXX XXX" className="w-full h-11 px-3 rounded-md bg-dark-2 border border-dark-4 text-sm text-light-1 placeholder:text-light-4 focus:outline-none focus:border-lime-1 transition-colors" data-id="element-2693" />
        </Field>
      </div>

      <Field label="Mesaj pentru chiriaș" data-id="element-2694">
        <textarea value={message} onChange={e => onChange({
        message: e.target.value
      })} rows={5} placeholder="Descrie pe scurt proprietatea și de ce crezi că se potrivește..." className="w-full p-3 rounded-md bg-dark-2 border border-dark-4 text-sm text-light-1 placeholder:text-light-4 focus:outline-none focus:border-lime-1 transition-colors resize-y" data-id="element-2695" />
      </Field>

      <div className="flex items-start gap-3 pt-1" data-id="element-2696">
        <input type="checkbox" id="terms" checked={termsAccepted} onChange={e => onChange({
        termsAccepted: e.target.checked
      })} className="mt-1 w-4 h-4 rounded border-dark-4 bg-dark-2 accent-lime-1 focus:ring-lime-1 focus:ring-offset-dark-2" data-id="element-2697" />
        <label htmlFor="terms" className="text-sm text-light-3 leading-relaxed" data-id="element-2698">
          Sunt de acord cu{' '}
          <a href="/termeni" className="text-light-2 hover:text-light-1 underline underline-offset-2" data-id="element-2699">
            Termenii și Condițiile
          </a>{' '}
          platformei și confirm că datele introduse sunt corecte.
        </label>
      </div>
    </div>;
}
function Field({
  label,
  children
}: {
  label: React.ReactNode;
  children: React.ReactNode;
}) {
  return <div className="space-y-2" data-id="element-2700">
      <label className="text-sm font-medium text-light-2 block" data-id="element-2701">{label}</label>
      {children}
    </div>;
}